import React, { useEffect, useState } from 'react'
import SideBar from '../../Layout/Sidebar'
import '../../../Components/Styles/App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceFrown } from '@fortawesome/free-solid-svg-icons';

export default function Marketplace() {
  const [time, setTime] = useState(13 * 3600 + 24 * 60 + 48);

  useEffect(() => {
    if (time <= 0) return;

    const timer = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [time]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const top_players = [
    {
      id: 1,
      bid: "Current bid",
      name: "Maximus Dribbleton",
      thumbnail: "/assets/player/player1.svg",
      title: "Patterfly Studio",
      price: "21.6 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 2,
      bid: "Current bid",
      name: "Leo Passini",
      thumbnail: "/assets/player/player2.svg",
      title: "PhotoLution",
      price: "19.2 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 3,
      bid: "Current bid",
      name: "Wen Yan",
      thumbnail: "/assets/player/player3.svg",
      title: "MX Clone",
      price: "17.5 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 4,
      bid: "Current bid",
      name: "Athens",
      thumbnail: "/assets/player/player4.svg",
      title: "The Artificial",
      price: "15.9 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    }
  ];
  return (
    <div className='flex flex-col h-screen bg-[#0E081B] text-white'>
      <div className='flex flex-col flex-grow lg:flex-row overflow-hidden'>
        <SideBar />
        <div className='w-[100%] lg:w-[90%] p-5 lg:px-10 overflow-y-auto pt-10 lg:pt-20'>
          <p className='text-xl font-medium tracking-widest uppercase'>Top Player’s</p>
          <div className={`mt-5 ${top_players.length > 0 ? 'grid grid-cols-1 gap-5 lg:grid-cols-4' : ''}`}>
            {top_players.length > 0 ? (
              top_players.slice(0, 4).map((collection) => (
                <div key={collection.id} className='p-[1px] overflow-hidden relative rounded-3xl bg-white/10'>
                  <div className='dashboard-gradient animate-spin-slow'></div>
                  <div className='relative rounded-3xl py-5 px-5 bg-gradient-to-br from-[#0e0c15] via-[#120d20] to-[#141633]'>
                    <div className='flex justify-between'>
                      <div>
                        <p>{collection.bid}</p>
                        <p className='flex justify-start items-center gap-1'><img src={collection.image}></img>&nbsp;{collection.price}</p>
                      </div>
                      <div>
                        <button className='cursor-pointer text-white rounded-full py-1 bg-gradient-to-r from-[#2F1073] via-[#5C1FE2] to-[#2F1073] px-5'>Place bid</button>
                      </div>
                    </div>
                    <div className='flex justify-center'>
                      <img src={collection.thumbnail}></img>
                    </div>
                    <div className='flex justify-between items-center gap-5 mt-3 '>
                      <p className='font-bold text-xl uppercase truncate'>{collection.name}</p>
                      <p className='text-sm text-nowrap'>ENDS &nbsp;{formatTime(time)}</p>
                    </div>
                  </div>
                </div>
              ))) : (
              <div className='flex flex-col items-center gap-3 text-xl font-medium'>
                <FontAwesomeIcon icon={faFaceFrown} />
                <p>No data</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
